export default __webpack_public_path__ + "static/media/BodyGame_12.03e00eb3.png";